// eslint-disable-next-line no-shadow
enum OpsRole {
    Admin = 'Admin',
    OperationLead = 'OperationLead',
    OperationUser = 'OperationUser',
    MarketingUser = 'MarketingUser',
}

export default OpsRole;
